export const MICROSECONDS_IN_SECOND = 1_000_000;
